import { useEffect } from "react";
import LoyaltyAccessor from "@/components/account/loyaltyAccessor";
import { BankedCurrency } from "@/components/account/rewards/banked-currency";
import { RewardsFooter } from "@/components/account/rewards/footer";
import LoyaltyState from "@/components/account/rewards/loyaltyState";
import { MyOffers } from "@/components/account/rewards/my-offers";
import { MyRewards } from "@/components/account/rewards/my-rewards";
import {
  StyledSecondarySection,
  StyledTopLevelLoyaltyContainer,
} from "@/components/account/styles";
import Layout from "@/components/app/layout/index";
import { RestrictedAccountRoute } from "@/components/restrict";
import { LOYALTY_ACCESSOR_TYPES, LOYALTY_FEATURES } from "@/constants/loyalty";
import { useSelector } from "@/redux";
import { useAccountDispatch } from "@/redux/me/use-account";
import { userLoggedIn } from "@/utils/auth";

const RewardsPage = () => {
  const {
    dispatch,
    fetchRewardsHistory,
    fetchRedeemables,
    fetchOffers,
    fetchLoyaltyState,
    fetchRedemptions,
  } = useAccountDispatch();

  const loyaltyState = useSelector((state) => state.app.me.loyaltyState);

  useEffect(() => {
    if (userLoggedIn()) {
      dispatch(fetchRewardsHistory());
      dispatch(fetchRedeemables());
      dispatch(fetchOffers());
      dispatch(fetchLoyaltyState());
      dispatch(fetchRedemptions());
    }
  }, []);

  // Don't render rewards page until we have loyaltyState
  return (
    <RestrictedAccountRoute>
      <Layout>
        {loyaltyState && (
          <StyledTopLevelLoyaltyContainer>
            <LoyaltyAccessor
              checkType={LOYALTY_ACCESSOR_TYPES.FEATURE}
              checkName={LOYALTY_FEATURES.SHOW_LOYALTY_STATE}
              component={<LoyaltyState />}
            />
            <StyledSecondarySection>
              <LoyaltyAccessor
                checkType={LOYALTY_ACCESSOR_TYPES.FEATURE}
                checkName={LOYALTY_FEATURES.INDEX_REDEEMABLES}
                component={<MyRewards />}
              />
              <BankedCurrency />
              <LoyaltyAccessor
                checkType={LOYALTY_ACCESSOR_TYPES.FEATURE}
                checkName={LOYALTY_FEATURES.INDEX_MY_REWARDS}
                component={<MyOffers />}
              />
            </StyledSecondarySection>
            <RewardsFooter />
          </StyledTopLevelLoyaltyContainer>
        )}
      </Layout>
    </RestrictedAccountRoute>
  );
};

export default RewardsPage;
